import axios from "@/services/axios.config";
import { ReviewComment } from "@/types/Methodology";
import { toastOnError } from "@/utils/toastOnError";
import { useQuery } from "@tanstack/react-query";

type ReqParamsType = {
	methodologyRoundId: string;
};

const getMethodologyReviewComments = async (data: ReqParamsType) =>
	await axios
		.get<APIResponse<ReviewComment[]>>("methodology/round-comment", {
			params: data,
		})
		.then((res) => res.data.data as ReviewComment[])
		.catch((err) => Promise.reject(err.response.data as APIResponse));

export default function useGetMethodologyReviewComments(methodologyRoundId: string | undefined) {
	return useQuery({
		queryKey: [
			"reviewComments",
			typeof methodologyRoundId === "string" ? parseInt(methodologyRoundId) : methodologyRoundId,
		],
		queryFn: () => getMethodologyReviewComments({ methodologyRoundId: methodologyRoundId! }),
		enabled: !!methodologyRoundId,
		retry: 0,
		onError: (err: APIResponse) => {
			toastOnError(err);
		},
	});
}
